module.exports = __webpack_public_path__ + "media/src/admin/images/maintenance-bg-8ad628a8fc46fc22418ccfa905fee307.jpg";